import { Link } from 'react-router-dom';
import { dailyTracking } from '@/mocks/articles';

export default function DailySection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            <strong>今日追踪动态</strong>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            实时更新的爆料线索
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-6">
            {dailyTracking.map((item, index) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                {/* Dot */}
                <div className={`absolute left-[13px] md:left-[21px] w-2.5 h-2.5 rounded-full border-2 border-background-50 z-10 ${
                  index === 0 ? 'bg-primary-500' : 'bg-secondary-400'
                }`}></div>

                {/* Card */}
                <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300">
                  <div className="flex items-center gap-2 shrink-0">
                    <span className="text-xs font-semibold text-primary-500 bg-primary-50 px-2 py-0.5 rounded-md whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.time}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 flex-1 leading-snug">
                    {item.title}
                  </h3>
                  <Link
                    to={`/article/${item.id}`}
                    className="text-primary-500 text-xs font-medium hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1 shrink-0"
                  >
                    追踪详情
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}